import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { fetchContent } from "./api";

const SiteContentContext = createContext(null);

export const SiteContentProvider = ({ children }) => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    try {
      const res = await fetchContent();
      setContent(res.data.data || {});
    } catch (e) {
      console.error("Failed to load site content", e);
      setContent({});
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return (
    <SiteContentContext.Provider value={{ content: content || {}, loading, reload }}>
      {children}
    </SiteContentContext.Provider>
  );
};

export const useSiteContent = () => {
  const ctx = useContext(SiteContentContext);
  return ctx || { content: {}, loading: false, reload: () => {} };
};

/* Helper: safely read a nested section with fallback. */
export const useSection = (key, fallback = {}) => {
  const { content } = useSiteContent();
  return { ...fallback, ...(content[key] || {}) };
};
